<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	priceMsg: '',
	btnTxt: 'Buy Now',
	link: '',
	priceInfo: '',
}
const schema = defineSchema({
	priceMsg: $.richtext('Lead Message', { basic: true }),
	btnTxt: $.text('Button Text'),
	link: $.text('Button Link'),
	priceInfo: $.richtext('Note', { basic: true }),
})
export const BlockCTA = defineBlock({
	pickerHidden: true,
	thumbnail: '/block-thumbs/StoreBuyBox.svg',
	category: 'CTA',
	order: 360,
	name: 'BlockCTA',
	label: 'CTA Box',
	icon: 'shopping_cart',
	schema,
	defaults,
})
</script>
<script setup lang="ts">
import { computed } from 'vue'

import { Btn } from '@bagelink/vue'
import { useBoundPageItem } from '@/composables/useBoundPageItem'

/**
 * Generic call-to-action box: a lead message, a prominent button, and a note.
 * Used as the store "buy box" but reusable for any CTA (donate, subscribe, …).
 *
 * Prefers the bound datastore item ($page) fields, falling back to editor props.
 */




const props = defineProps<{
	priceMsg?: string
	btnTxt?: string
	link?: string
	priceInfo?: string
}>()

const bound = useBoundPageItem<Record<string, any>>()

const priceMsg = computed(() => bound.value?.priceMsg ?? props.priceMsg ?? '')
const btnTxt = computed(() => bound.value?.btnTxt ?? props.btnTxt ?? 'Buy Now')
const link = computed(() => bound.value?.link ?? props.link ?? '')
const priceInfo = computed(() => bound.value?.priceInfo ?? props.priceInfo ?? '')
</script>

<template>
	<div class="px-1">
		<div
			class="w760px mx-auto py-3 border-top border-bottom mt-3 mb-2 txt-center storeTextm_mt-1 m_mb-1 m_pt-2 m_pb-1 border-black"
		>
			<div class="pretty bold txt17 m_txt15" v-html="priceMsg" />
			<Btn size="xl" :href="link" target="_blank" class="my-2 bg-red-130 radius-05">
				{{ btnTxt }}
			</Btn>
			<div class="italic txt17 m_txt15" v-html="priceInfo" />
		</div>
	</div>
</template>
